import React from 'react';
import { ListContextValue } from './types';

export const ListContext = React.createContext<ListContextValue | null>(null);

export function useListContext<T extends any = any>(): ListContextValue<T> {
    const context = React.useContext(ListContext);
    if (!context) {
        throw new Error('useListContext must be used within a List');
    }
    return context;
}
